// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.

type SvType =
  | 'Deletion'
  | 'Insertion'
  | 'Inversion'
  | 'InDel'
  | 'Translocation'
  | 'Duplication'
  | 'Other';

export const HceSvColorList = {
  Deletion: 'rgb(192,80,77)',
  Insertion: 'rgb(79,129,189)',
  Inversion: 'rgb(155,187,89)',
  InDel: 'rgb(255,153,50)',
  Translocation: 'rgb(162,40,255)',
  Duplication: 'rgb(116,192,242)',
  Other: 'rgb(221,221,221)',
} as const satisfies Readonly<Record<SvType, string>>;
